import VehicleTracking from "@/models/VehicleTracking";

export default class VehicleTrackingTransformer {

    transform (data) {
        return new VehicleTracking(
            data.lt,
            data.lg,
            data.hg,
            data.sp,
            data.hardId,
        );
    }

}
